import { UserGroup } from 'able-lib'

export interface SectionStateInterface {
  levelsAndSections: Array<any>;
  currentSectionUsers: Array<number>;
  students: Array<UserGroup>;
  teachers: Array<UserGroup>;
  selectedLevel: {
    id: number;
    name: string;
  };
}

export default function (): SectionStateInterface {
  return {
    levelsAndSections: [],
    currentSectionUsers: [],
    students: [],
    teachers: [],
    selectedLevel: {
      id: 0,
      name: 'ALL'
    }
  }
}
